





























































import Vue from "vue";
import moment from "moment";

// Vue components
import DeviceTreeAppPage from "@/components/DeviceTreeAppPage.vue";
import RemoteMessageEditorCard from "./RemoteMessageEditorCard.vue";
import { GetDataFlowOrganizationsConvertersResData } from "@/model/communication/dataFlow/GetDataFlowOrganizationsConvertersResData";
import { GetDataFlowOrganizationsConvertersCommand } from "@/model/communication/dataFlow/GetDataFlowOrganizationsConvertersCommand";
import { GetDataFlowMetricsCommand } from "@/model/communication/dataFlow/GetDataFlowMetricsCommand";
import { GetDataFlowMetricsResData } from "@/model/communication/dataFlow/GetDataFlowMetricsResData";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import ServicesMetricsCard from "./ServicesMetricsCard.vue";
import { mapGetters } from "vuex";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";

export default Vue.extend({
    components: {
        DeviceTreeAppPage,
        RemoteMessageEditorCard,
        ServicesMetricsCard,
    },
    data() {
        return {
            deviceTreeSelectedObjectItems: [],
            converters: [],
            selectedConverter: null,
            loading: false,
            loadingMetrics: false,
            showError: false,
            errorMessage: "",
            isOpened: 0,
            metrics: null,
            showErrorMetrics: false,
            errorMessageMetrics: null,
            metricsLoadedAt: null,
        };
    },
    computed: {
        ...mapGetters(["authUserHasPrivilege"]),
        selectedInstallation() {
            if (this.deviceTreeSelectedObjectItems && this.deviceTreeSelectedObjectItems.length == 1) return this.deviceTreeSelectedObjectItems[0].name;
            return null;
        },

        isAllowedServicesManagement() {
            return this.authUserHasPrivilege(ClientPrivileges.DataFlowServicesManagement);
        },
        isAllowedRemoteMessageManagement() {
            return this.authUserHasPrivilege(ClientPrivileges.DataFlowRemoteMessageManagement);
        },
    },
    methods: {
        reload() {
            window.dispatchEvent(new CustomEvent("reload-remote-message-editor-card"));
        },
        async getOrganizationsConverter() {
            this.loading = true;
            try {
                let response: GetDataFlowOrganizationsConvertersResData = await new GetDataFlowOrganizationsConvertersCommand(false).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success && response.responseString == "Success") {
                    this.converters = response.converterTypes;
                } else {
                    this.showError = true;
                    this.errorMessage = this.$t("dataFlow.errorGetConverter", { message: response.message });
                }
            } catch (e) {
                console.log("Something went wrong sending PostDataFlowDeviceDetailsCommand request ", e);
            }
            this.loading = false;
        },
        async getMetrics() {
            this.loadingMetrics = true;
            this.metricsLoadedAt = moment.utc().format();
            try {
                let response: GetDataFlowMetricsResData = await new GetDataFlowMetricsCommand().execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success && response.responseString == "Success") {
                    this.metrics = response.metrics;
                } else {
                    this.showErrorMetrics = true;
                    this.errorMessageMetrics = this.$t("dataFlow.errorGetMetrics", { message: response.message });
                }
            } catch (e) {
                console.log("Something went wrong sending GetDataFlowMetricsCommand request ", e);
            }
            this.loadingMetrics = false;
        },
        async reloadMetrics() {
            await this.getMetrics();
        },
    },
    async mounted() {
        this.loading = true;
        await this.getMetrics();
        await this.getOrganizationsConverter();
        if (this.converters && this.converters.length) this.selectedConverter = this.converters[0];
    },
});
